import classNames from 'classnames';
import { map } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import ColorSwatchButton from 'components/ColorSwatchButton';
import Label from 'components/Label';
import Theme from 'styles/theme';
import Colors from 'utils/Colors';
import I18n from 'utils/I18n';

import { COLOR_SWATCH_BUTTON_DIAMETER } from './constants';

const ColorOptions = ({ filterIdentifier, options, onFilterOptionSelect }) => (
  <ul className="CollectionFilterSelector__colorOptions">
    {map(options, ({ option, value }) => (
      <li className="CollectionFilterSelector__listItem" key={option}>
        <Label
          className={classNames('ColorOption__label', {
            'ColorOption__label--bold': value,
          })}
        >
          <ColorSwatchButton
            className={classNames('ColorOptions__button')}
            onClick={() => onFilterOptionSelect({ option, value: !value })}
            colors={Colors.getHex(option)}
            ariaLabel={I18n.localize(
              `productAttributes.${filterIdentifier}.options.${option}.label`
            )}
            isSelected={value}
            diameter={COLOR_SWATCH_BUTTON_DIAMETER}
          />
          {I18n.localize(`productAttributes.${filterIdentifier}.options.${option}.label`)}
        </Label>
      </li>
    ))}
    <style jsx>
      {`
        .CollectionFilterSelector__listItem {
          padding-bottom: ${Theme.get('spacing') * 1.5}px;
        }
      `}
    </style>
    <style jsx global>
      {`
        .CollectionFilterSelector__listItem .ColorSwatchButton {
          width: 20px;
          height: 20px;
          margin-right: ${Theme.get('spacing') * 2}px;
        }

        .ColorOption__label.Label {
          display: flex;
          align-items: center;
          cursor: pointer;
        }

        .ColorOption__label--bold.Label {
          font-weight: ${Theme.get('font-weight-bold')};
        }
      `}
    </style>
  </ul>
);

ColorOptions.propTypes = {
  filterIdentifier: PropTypes.string.isRequired,
  onFilterOptionSelect: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ColorOptions;
